import { useMemo } from 'react';
import useMock, { Configuration as MockConfiguration } from './useMock';
import useProduct from './useProduct';
import useQuestions, { Configuration as QuestionsConfiguration } from './useQuestions';
import { ConfigurationModel } from '../components/hoc/context/product/configuration-model';
import useForms, { Configuration as FormsConfiguration } from './useForms';

export type Configuration = {
	product: ConfigurationModel;
	questions: QuestionsConfiguration;
	forms: FormsConfiguration;
	mock?: MockConfiguration;
};

export default function useConfiguration(): Configuration {
	const mock = useMock();
	const product = useProduct();
	const questions = useQuestions();
	const forms = useForms();

	return useMemo(() => {
		return {
			product: product,
			mock: mock.isMockAllowed ? mock : undefined,
			questions: questions,
			forms: forms,
		};
	}, [product, mock, questions, forms]);
}
